module.exports = {
    contact: 'form-contact',
    career: 'form-career',
    privateLabel: 'form-private-label',
    signup: 'form-catalog-signup',
}